import type { DeepNonNullable } from 'ts-essentials';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Price } from '@/components/Price';
import { Typography } from '@/components/Typography';
import type { MoneyFragment, TaxedMoneyFragment } from '@/graphql/saleor/api';
import { useIsMdDown } from '@/hooks/useMedia';
import type { Maybe } from '@/lib/types';
import type { CheckoutState } from '@/states/checkout';

import * as GM from '../../messages';
import * as S from './PreOrderInfo.styles';

interface PreOrderInfoProps extends DeepNonNullable<
  Pick<CheckoutState, 'preOrderData'>
> {
  price: Maybe<TaxedMoneyFragment>;
}
export const PreOrderInfo = ({
  preOrderData: { deposit, deposit_percentage },
  price,
}: PreOrderInfoProps) => {
  const isMdDown = useIsMdDown();

  return (
    <>
      <Box data-testid='PreOrderInfoBox' />
      <Flex
        alignItems='flex-end'
        flexDirection='column'
        width={isMdDown ? '100%' : undefined}
      >
        <S.DepositInfo data-testid='PreOrderInfoDepositInfo'>
          <Typography data-testid='PreOrderInfoDepositText'>
            {GM.Deposit} {deposit_percentage}%
          </Typography>
          <Price
            data-testid='PreOrderInfoPrice'
            price={
              { currency: price?.currency, amount: deposit } as MoneyFragment
            }
          />
        </S.DepositInfo>
      </Flex>
    </>
  );
};
